

'use strict';

import $ from 'jquery';

const oClickHandler = require('../../cms/js/modules/clickHandlers.js');
const clickHandler = new oClickHandler();

export default function insertTableRow () {
    const id = $(this).data('id');
    const parentRow = $(this).closest('tr');
    const colCount = $('#table_id thead th').length;

    clickHandler.edit(id)
        .then(response => {
            const $infoCol = $('<td colspan="'+ colCount +'">')
                .html(response[0]);

            const $infoRow = $('<tr>')
                .addClass('info-row')
                .html($infoCol)
                .hide();

            if (parentRow.next().is('.info-row')) {
                parentRow.next('.info-row').remove();
            }
            else {
                parentRow.after($infoRow);
                $infoRow.show();
            }
        });
}
